export default __webpack_public_path__ + "static/media/card4.00568c11.svg";